/*
 * Os endereços antigos do portal do sócio (o "Dashboard" com separadores em /?tab=…) continuam a funcionar: quem tem um favorito, um e-mail, uma
 * notificação ou um atalho do telemóvel com um deles é levado ao sítio novo. Cada endereço novo diz o que é (reservas, treino, plano…).
 */
export const LEGACY_TAB_TARGETS = {
  dashboard: '/',
  booking: '/reservas',
  mybookings: '/reservas/minhas',
  workout: '/meu-treino/plano',
};

/** Um endereço (possivelmente antigo) → o endereço de hoje. Tudo o que não é antigo passa tal e qual. */
export function legacyHomeTarget(url) {
  if (typeof url !== 'string') return '/';
  const m = url.match(/^\/\?tab=([a-z]+)/i);
  if (m) return LEGACY_TAB_TARGETS[m[1].toLowerCase()] || '/';
  if (url === '/home') return '/';
  return url;
}

/** Para a rota "/": o destino se a pesquisa traz um separador antigo (?tab=…), senão null (é o Início). */
export function legacyTabRedirect(search) {
  const tab = new URLSearchParams(search || '').get('tab');
  if (!tab) return null;
  return LEGACY_TAB_TARGETS[tab.toLowerCase()] ?? '/';
}
